import React from 'react';
import './Landing.css'; // Import your CSS file

const Landing = () => {
    return (
        <div>
            {/* Hero Section */}
            <header className="hero text-center">
                <h1>Discover Your Dreams with EasyDreams</h1>
                <p>Your personal companion for understanding and tracking your dreams.</p>
                <a
                    href="https://play.google.com/store/apps/details?id=com.trypuz.easy_dreams"
                    className="btn btn-primary"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Get it on Google Play
                </a>
                <div className="hero-images">
                    <img
                        src="en-1.png"
                        alt="App Screenshot 1"
                        className="hero-image"
                    />
                    <img
                        src="en-3.png"
                        alt="App Screenshot 2"
                        className="hero-image"
                    />
                </div>
            </header>

            {/* Features Section */}
            <section className="container my-5">
                <h2>Unlock the Power of Your Dreams</h2>
                <ul className="features">
                    <li>
                        <img
                            src="icons/diary.ico"
                            alt="Dream Journal Icon"
                            className="feature-icon"
                        />
                        <strong>Dream Journal:</strong> Easily record your dreams every morning with a simple and
                        intuitive interface.
                    </li>
                    <li>
                        <img
                            src="icons/ai.ico"
                            alt="AI Insights Icon"
                            className="feature-icon"
                        />
                        <strong>AI-Powered Interpretations:</strong> Understand the meaning of your dreams with the help
                        of AI.
                    </li>
                    <li>
                        <img
                            src="/icons/calendar.ico"
                            alt="Dream Calendar Icon"
                            className="feature-icon"
                        />
                        <strong>Dream Calendar:</strong> Visualize your dreams over time and explore trends in your
                        dreaming habits.
                    </li>
                    <li>
                        <img
                            src="/icons/moon.ico"
                            alt="Dream's Wiki"
                            className="feature-icon"
                        />
                        <strong>Dream's Wiki:</strong> Find your dream's description in our big database.
                    </li>
                </ul>
            </section>

            {/* Call-to-Action Section */}
            <section className="cta text-center my-5">
                <h2>Start Your Journey Today</h2>
                <p>Download EasyDreams now and begin your path to better dreams and sleep!</p>
                <a
                    href="https://play.google.com/store/apps/details?id=com.trypuz.easy_dreams"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                        alt="Google Play Download Badge"
                        className="google-play-badge"
                    />
                </a>
            </section>

            {/* Testimonials Section */}
            <section className="container my-5">
                <h2>Hear from Our Users</h2>
                <blockquote>
                    <p>“EasyDreams has completely changed the way I think about my sleep and dreams. The AI insights are incredible!”</p>
                    <footer>– Emily P.</footer>
                </blockquote>
                <blockquote>
                    <p>“I love how easy it is to log my dreams every morning. It feels like therapy in my pocket.”</p>
                    <footer>– Jack M.</footer>
                </blockquote>
            </section>
        </div>
    );
};

export default Landing;